<template>
  <div class="fcl-detail-container">
    <navbar :showShadow="true" :scrollChange="false" :tabId="5"></navbar>

    <div class="content-area">
      <div class="left-area">
        <div class="left-wrapper">
          <div class="port-panel">
            <div class="row-1">
              <div class="shipping">
                <img
                  class="icon"
                  :src="
                    baseData.shippinglogo
                      ? baseData.shippinglogo
                      : require('@/images/common/shipping.png')
                  "
                />
                <div class="text">{{ baseData.shippingStr }},</div>
              </div>
              <div class="date">
                {{ baseData.scheduleCutoff }}（{{ baseData.beginDateStr }}-{{
                  baseData.endDateStr
                }}）
              </div>
            </div>
            <div class="split"></div>
            <div class="row-2">
              <div class="port start">
                <div class="en">{{ baseData.portStartStr }}</div>
                <div class="cn">{{ baseData.portStartStrCn }}</div>
              </div>
              <div class="arrow">
                <div class="voyage">{{ baseData.voyage }}天</div>
                <img class="icon" src="@/images/checkFreightRate/arrow.png" />
                <div class="transfer">
                  <div class="text" v-if="+baseData.transferFlag === 1">直达</div>
                  <div class="text" v-if="+baseData.transferFlag === 2">{{baseData.transferStr}}</div>
                </div>
              </div>
              <div class="port end">
                <div class="en">{{ baseData.portEndStr }}</div>
                <div class="cn">{{ baseData.portEndStrCn }}</div>
              </div>
            </div>
            <div class="row-3 dis_f_l_c">
              <div class="">
                20GP <span class="common-orange">${{ baseData.price20 }}</span
                >，
              </div>
              <div class="">
                40GP <span class="common-orange">${{ baseData.price40 }}</span
                >，
              </div>
              <div class="">
                40HQ
                <span class="common-orange">${{ baseData.price40hq }}</span>
              </div>
            </div>
          </div>
          <div class="fee-panel">
            <div class="title">附加费用</div>
            <div class="table">
              <el-table :data="baseData.oceanFreightList || []" border stripe>
                <el-table-column
                  label="费用名称"
                  prop="chargeName"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  label="20GP"
                  prop="price20"
                  show-overflow-tooltip
                >
                  <template v-slot="{ row }"
                    ><div class="" v-if="row.price20 !== null">
                      {{$currencyShow(row.currency)}}{{ row.price20 }}
                    </div>
                    <div class='' v-else>-</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="40GP"
                  prop="price40"
                  show-overflow-tooltip
                >
                  <template v-slot="{ row }"
                    ><div class="" v-if="row.price40 !== null">
                      {{$currencyShow(row.currency)}}{{ row.price40 }}
                    </div>
                    <div class='' v-else>-</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="40HQ"
                  prop="price40hq"
                  show-overflow-tooltip
                >
                  <template v-slot="{ row }"
                    ><div class="" v-if="row.price40hq !== null">
                      {{$currencyShow(row.currency)}}{{ row.price40hq }}
                    </div>
                    <div class='' v-else>-</div>
                  </template>
                </el-table-column>
                <el-table-column label="单票" prop="unit" show-overflow-tooltip>
                  <template v-slot="{ row }"
                    ><div class="" v-if="row.priceBill !== null">
                      {{$currencyShow(row.currency)}}{{ row.priceBill }}
                    </div>
                    <div class='' v-else>-</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="desc-panel">
            <div class="title">备注信息</div>
            <div class="desc">
              {{baseData.description}}
            </div>
          </div>
          <div class="btn-panel">
            <el-button type="primary" class="btn" @click="quotationClick"
              >制作报价单</el-button
            >
          </div>
        </div>
      </div>
      <div class="right-area">
        <div class="right-wrapper">
          <div class="row-1">联系供应商</div>
          <div class="row-2">
            {{ baseData.supplierName }}-{{ baseData.companyStr }}
          </div>
          <div class="row-3">
            <div class="label">联系电话 (同微信）</div>
            <div class="value">{{ baseData.supplierTel }}</div>
          </div>
          <div class="row-3">
            <div class="label">电子邮箱</div>
            <div class="value">{{ baseData.supplierEmail }}</div>
          </div>
          <div class="row-3">
            <div class="label">QQ</div>
            <div class="value hand" @click="addQQ(baseData.supplierQq)">{{ baseData.supplierQq }}</div>
          </div>
        </div>
      </div>
    </div>
    <quotation-dialog
      @close="showQuotation = false"
      v-if="showQuotation"
      :chooseData="baseData"
    ></quotation-dialog>
  </div>
</template>

<script>
import { fclDetailAPI } from "@/api/checkFreightRate/checkFreightRate";

export default {
  data() {
    return {
      id: "",
      baseData: {},
      showQuotation: false,
    };
  },
  components: {
    QuotationDialog: () => import("./components/quotation-dialog"),
  },
  created() {
    // 登录校验在顶层统一控制
    // 参数校验
    this.pageCheck();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.initDetail();
  },

  mounted() {},
  methods: {
    pageCheck() {
      if (!this.$route.query.id) {
        console.error("id不存在!");
        this.$router.replace({
          path: "/checkFreightRate",
        });
        throw new Error("id不存在!");
      }
    },
    // 获取详情
    async initDetail() {
      try {
        let params = { id: this.id };
        let res = await fclDetailAPI(params);
        this.baseData = res;
      } catch (e) {
        console.error(e);
      }
    },
    // 制作报价单
    quotationClick() {
      this.showQuotation = true;
    },
    // qq聊天
    addQQ(qq){
        if(qq){
          window.location.href="tencent://AddContact/?fromId=45&fromSubId=1&subcmd=all&uin="+qq+"&website=www.oicqzone.com"
        }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variable.scss";
.fcl-detail-container {
  @mixin themeTransition {
    transition: all 0.2s;
  }
  padding: $navbarHeight 0 0 0;
  background: #f5f9ff;
  width: 100%;
  .content-area {
    width: $contentWidth;
    margin: auto;
    padding: 20px 0 106px;
    min-height: calc(100vh - #{$navbarHeight} - #{$footerHeight});
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left-area {
      width: 814px;
      flex: 0 0 auto;
      .left-wrapper {
        .port-panel {
          width: 100%;
          background: #ffffff;
          border-radius: 10px;
          padding: 20px 20px 30px;

          .row-1 {
            display: flex;
            align-items: center;
            font-size: 13px;
            font-weight: 400;
            color: #45484e;
            .shipping {
              display: flex;
              align-items: center;
              margin-right: 6px;
              .icon {
                display: block;
                width: 24px;
                border-radius: 50%;
              }
              .text {
                padding-left: 10px;
              }
            }
            .date {
            }
          }
          .split {
            width: 100%;
            height: 1px;
            background: #f4f6f8;
            margin: 20px 0 22px;
          }
          .row-2 {
            display: flex;
            align-items: center;
            .port {
              overflow: hidden;
              .en {
                font-size: 18px;
                font-weight: bold;
                color: #373842;
              }
              .cn {
                margin-top: 4px;
                font-size: 12px;
                font-weight: 500;
                color: #555965;
              }
              &.end {
                overflow: hidden;
                .en,
                .cn {
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
            }

            .arrow {
              flex: 0 0 auto;
              width: 72px;
              height: 7px;
              margin: 0 25px;
              font-size: 12px;
              font-weight: 500;
              color: #808795;
              position: relative;
              .voyage {
                position: absolute;
                top: -16px;
                width: 100%;
                text-align: center;
              }
              .icon {
                display: block;
                width: 42px;
                height: auto;
                margin: auto;
                white-space: nowrap;
 
              }
              .transfer {
                position: absolute;
                bottom: -16px;
                width: 100%;
                text-align: center;
                .text {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
 
                }
             }
            }
          }
          .row-3 {
            margin-top: 30px;
            width: 100%;
            background: #f6f8fa;
            border-radius: 6px;
            padding: 10px;
          }
        }
        .fee-panel {
          margin-top: 10px;
          width: 100%;
          background: #ffffff;
          border-radius: 12px;
          padding: 20px 20px 30px;

          .title {
            font-size: 14px;
            font-weight: bold;
            color: #373842;
          }
          .table {
            margin-top: 20px;
          }
        }
        .desc-panel {
          margin-top: 10px;
          width: 100%;
          background: #ffffff;
          border-radius: 12px;
          padding: 20px 20px 30px;
          .title {
            font-size: 14px;
            font-weight: bold;
            color: #373842;
            margin-bottom: 14px;
          }
          .desc {
            font-size: 12px;
            font-weight: 500;
            color: #555965;
            line-height: 18px;
          }
        }
        .btn-panel {
          margin-top: 30px;
          width: 100%;
          .btn {
            width: 100%;
            height: 48px;
            border-radius: 10px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
          }
        }
      }
    }
    .right-area {
      width: 366px;
      background: #ffffff;
      border-radius: 10px;
      .right-wrapper {
        padding: 20px 20px 50px;
        .row-1 {
          font-size: 16px;
          font-weight: bold;
          color: #373842;
        }
        .row-2 {
          margin-top: 24px;
          font-size: 14px;
          font-weight: bold;
          color: #373842;
        }
        .row-3 {
          margin-top: 20px;
          .label {
            font-size: 12px;
            font-weight: 400;
            color: #808795;
          }
          .value {
            font-size: 14px;
            font-weight: 500;
            color: #45484e;
            margin-top: 8px;
          }
        }
      }
    }
  }
}
</style>
